export function isView(value) {
    return !!(value && typeof value === 'object' && value.useView && value.config);
}
export function getElementRef(element) {
    return element.ref;
}
export function getViewComponent(value) {
    if (isView(value)) {
        return value;
    }
}
// eslint-disable-next-line @typescript-eslint/no-explicit-any
let activeViewRevision;
export function getActiveViewRevision() {
    return activeViewRevision;
}
export function expectActiveViewRevision() {
    if (!activeViewRevision) {
        throw new Error('Expected an active view revision.');
    }
    return activeViewRevision;
}
export function setActiveViewRevision(revision) {
    activeViewRevision = revision;
}

//# sourceMappingURL=util.js.map